// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import {getStorage} from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD59i0MpxGLObJPs_Yx9-tanjLcydw_J9g",
  authDomain: "unilagbballleague.firebaseapp.com",
  projectId: "unilagbballleague",
  storageBucket: "unilagbballleague.appspot.com",
  messagingSenderId: "400008975977",
  appId: "1:400008975977:web:42c90a9b0b5eaae619b4f8",
  // measurementId: "G-1NM2TXHQFN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const storage = getStorage(app);

